module.exports = __webpack_public_path__ + "static/media/bb.7bd8b0ac.svg";